import { reverseTransformPoint } from "@/canv/utils";

type Coordinates = {
    top: number;
    left: number;
};

export function calculateMenuCoordinates(
    coordinates: Coordinates,
    menuRect: DOMRect,
    canvasRect: DOMRect,
) {
    const pt = reverseTransformPoint(coordinates.left, coordinates.top);

    const anchorX = canvasRect.left + pt.x;
    const anchorY = canvasRect.top + pt.y;

    const margin = 10;
    const minTopPad = 60;
    const offset = 50;

    let left = anchorX - menuRect.width / 2;
    let top = anchorY - menuRect.height - offset;

    const minLeft = canvasRect.left + margin;
    const maxLeft = canvasRect.right - margin - menuRect.width;

    const minTop = canvasRect.top + minTopPad;
    const maxTop = canvasRect.bottom - margin - menuRect.height;

    left = Math.min(Math.max(left, minLeft), maxLeft);
    top = Math.min(Math.max(top, minTop), maxTop);

    return { top, left };
}
